<template>
  <div class="wrapper wrapper-content animated fadeIn">
    <div class="row">
      <div class="mail-box">
        <table class="table table-hover table-mail">
          <thead class="table-head">
            <tr>
              <th>Titulo</th>
              <th>Descrição</th>
              <th>Monitor</th>
              <th>Lido</th>
              <th>Pendente</th>
              <th>Fechado</th>
              <th></th>
              <th>
                <button
                class="btn btn-outline add-button"
                type="button"
                @click="createRequest"
              >
                <i class="fa fa-plus text-success"></i>
              </button>
              </th>
            </tr>
          </thead>

          <tbody class="table-list">
            <tr v-for="(item, listIdx) in guardRequests.list" :key="listIdx">
              <td>{{ item.subject }}</td>
              <td>{{ item.description }}</td>
              <td>{{ item.employee ? item.employee.fullName : '' }}</td>
              <td>{{ item.isRead ? 'Sim' : 'Não' }}</td>
              <td>{{ item.isPending ? 'Sim' : 'Não' }}</td>
              <td>{{ item.isClosed ? 'Sim' : 'Não' }}</td>
              <td class="list-command">
                <button
                  class="btn btn-outline"
                  @click="selectRequest(item, listIdx)"
                >
                  <i class="fa fa-edit text-success"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { toast } from '@/plugins/toast';
export default {
  data() {
    return {
      searchForm: {
        fullName: '',
      },
      guardRequests: {
        originalList: [],
        list: [],
      },
    };
  },
  mounted() {
    this.listGuardRequests();
  },
  methods: {
    totalToCurrencyBR(value) {
      return (value / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      });
    },
    DateBR(dt) {
      return new Date(dt).toLocaleString('pt-br');
    },
    async listGuardRequests() {
      try {
        const guardRequests = await this.$store.dispatch(
          'GUARD-REQUEST/ListRequest',
        );

        this.guardRequests.list = guardRequests;
      } catch (error) {
        toast.error('Não foi possível listar as solicitações');
      }
    },
    selectRequest(item) {
      this.$router.push({
        name: 'ManagerGuardRequestEdit',
        params: { requestId: item._id },
      });
    },
    createRequest() {
      this.$router.push({
        name: 'ManagerGuardRequest',
      });
    },
  },
};
</script>